var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-progress-circular',{staticClass:"cntnr",attrs:{"color":"primary","size":"96","indeterminate":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }